import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";

export const influencerNoteContent: NoteContent[] = [
  {
    title: "Noah owes me $500",
    date: "Thu 23 May 2024",

    locked: false,
  },
  {
    title: "Gaverny - Yours perfume",
    date: "Tue 21 May 2024",

    locked: false,
  },
  {
    title: "+555 369-8420",
    date: "Mon 20 May 2024",

    locked: false,
  },
  {
    title: "Cave de Vignères",
    date: "Fri 17 May 2024",

    locked: false,
  },
  {
    title: "Subscription number 6274292",
    date: "Thu 16 May 2024",

    locked: false,
  },
  {
    title: "www.youtube/boilerroom/djerg",
    date: "Mon 13 May 2024",

    locked: false,
  },
  {
    title: "40,000 (access to pool)",
    date: "Thu 9 May 2024",

    locked: false,
  },
  {
    title: "Do you understand that although I want…",
    date: "Mon 6 May 2024",

    locked: false,
  },
  {
    title: "New Note",
    date: "Sat 4 May 2024",

    locked: false,
  },
];
